import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { useStateBasedProps } from './useStateBasedProps';
import { ImageProps, StateBasedProps } from '../Button/ButtonContent';

interface ButtonImageProps {
  imageUrl?: string;
  imageProps?: ImageProps | StateBasedProps<ImageProps>;
  isHovered: boolean;
  hoverEnabled: boolean;
  hasMultipleItems: boolean;
}

export const ButtonImage: React.FC<ButtonImageProps> = ({
  imageUrl,
  imageProps,
  isHovered,
  hoverEnabled,
  hasMultipleItems,
}) => {
  const currentImageProps = useStateBasedProps(imageProps, isHovered, hoverEnabled) || {};

  if (!imageUrl) return null;

  const getAlignItems = (alignSelf?: string) => {
    switch (alignSelf) {
      case 'flex-start':
        return 'flex-start';
      case 'center':
        return 'center';
      case 'flex-end':
        return 'flex-end';
      default:
        return 'center';
    }
  };

  const getJustifyContent = (justifySelf?: string) => {
    switch (justifySelf) {
      case 'flex-start':
        return 'flex-start';
      case 'center':
        return 'center';
      case 'flex-end':
        return 'flex-end';
      default:
        return 'center';
    }
  };

  const boxStyle: SxProps<Theme> = {
    display: 'flex',
    alignItems: getAlignItems(currentImageProps.alignSelf),
    justifyContent: getJustifyContent(currentImageProps.justifySelf),
    padding: currentImageProps.padding ?? 0,
    flex: hasMultipleItems ? '0 0 auto' : '1',
    height: '100%',
  };

  return (
    <Box sx={boxStyle}>
      <img
        src={imageUrl}
        alt=""
        style={{
          width: currentImageProps.width || 28,
          height: currentImageProps.height || 28,
          borderRadius: currentImageProps.borderRadius || 4,
          opacity: currentImageProps.opacity !== undefined ? currentImageProps.opacity / 100 : 1,
          objectFit: 'contain',
          verticalAlign: 'middle',
          display: 'inline-block',
          transition: 'all 0.2s ease',
        }}
      />
    </Box>
  );
};
